var _path, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49219 7.34783C2.49219 6.24326 3.38762 5.34783 4.49219 5.34783H7.49219L9.41494 3.54211C9.78577 3.19386 10.2754 3 10.7841 3H14.2003C14.709 3 15.1986 3.19386 15.5694 3.54211L17.4922 5.34783H20.4922C21.5968 5.34783 22.4922 6.24326 22.4922 7.34783V19C22.4922 20.1046 21.5968 21 20.4922 21H4.49219C3.38762 21 2.49219 20.1046 2.49219 19V7.34783Z",
    stroke: "#339999",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.99219,
    cy: 8.5,
    r: 1.5,
    fill: "#339999"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4922,
    cy: 13,
    r: 4,
    stroke: "#339999",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7d27c26e2e81f991416b86eabbb8f300.svg";
export { ForwardRef as ReactComponent };